export const homeConstant = {
  GET_fAQ_REQUEST: "GET_fAQ_REQUEST",
  GET_fAQ_SUCCESS: "GET_fAQ_SUCCESS",
  GET_fAQ_FAILURE: "GET_fAQ_FAILURE",

  CONTACT_REQUEST: "CONTACT_REQUEST",
  CONTACT_SUCCESS: "CONTACT_SUCCESS",
  CONTACT_FAILURE: "CONTACT_FAILURE",

  CAR_REGISTER_FORM_REQUEST: "CAR_REGISTER_FORM_REQUEST",
  CAR_REGISTER_FORM_SUCCESS: "CAR_REGISTER_FORM_SUCCESS",
  CAR_REGISTER_FORM_FAILURE: "CAR_REGISTER_FORM_FAILURE",

  GET_ALLBRANDS_REQUEST: "GET_ALLBRANDS_REQUEST",
  GET_ALLBRANDS_SUCCESS: "GET_ALLBRANDS_SUCCESS",
  GET_ALLBRANDS_FAILURE: "GET_ALLBRANDS_FAILURE",
};
